import { h, Component } from 'preact';
import Logo from './Logo';

const Footer = props => {
  return (
  	<div className="footer pt-4 clearfix">
    	<section class="container clearfix">
    	
    	
	    	<div className="pb-4 clearfix"> 
		    	<div className="grid1of1 pb-6 clearfix">
			        <div className="grid3of4">
			        	<Logo />
			        	<p className="fontSize1 fontRegular mt-3">Simple case management for Therapists</p>
			        </div>
			        {/*<div className="grid1of4">
			        	<ul className="inline-block">
			        		<li><a href="" className="link inline-block">Privacy Policy</a></li>
			        		<li><a href="" className="link inline-block">Privacy Policy</a></li>
			        		<li><a href="" className="link inline-block">Privacy Policy</a></li>
			        		<li><a href="" className="link inline-block">Privacy Policy</a></li>
			        	</ul>
			        </div> */}
			    </div>

			    <div className="grid1of1 clearfix">
			    	<div className="grid1of2">
			    		<p className="fontRegular" style={{fontSize: 12, color: "#999"}}>© Hovi Health</p>
			    		{/*
			    		<ul className="distribute distribute-inline">
			        		<li><a href="" className="link mr-2">Privacy Policy</a></li>
			        		<li><a href="" className="link mr-2">Privacy Policy</a></li>
			        		<li><a href="" className="link mr-2">Privacy Policy</a></li>
			        		<li><a href="" className="link mr-2">Privacy Policy</a></li>
			        	</ul>
			        	*/}
			    	</div>
			    </div>
			</div>
		

    	</section>
    </div>
  );
};  


export default Footer;



// WEBPACK FOOTER //
// ./components/Footer.js